import { ReactNode } from 'react'

import {
  AnEasySmile,
  ConfusedFace,
  DizzyFace,
  ExplodingHead,
  FaceWithSpiralEyes,
  Fire,
  ManFacepalming,
  NerdFace,
  NeutralFace,
  ThumbsUpLightSkinTone,
} from '@it-incubator/ui-kit'

export enum Reactions {
  BadOrganization = 'bad_organization',
  BadPresentation = 'bad_presentation',
  DidNotLikeThePresentation = 'did_not_like_the_presentation',
  EasyToUnderstand = 'easy_to_understand',
  GreatPresentation = 'great_presentation',
  HardToUnderstand = 'hard_to_understand',
  NoReview = 'no_review',
  ProfessionalMentor = 'professional_mentor',
  TooMuchInformation = 'too_much_information',
  UsefulLesson = 'useful_lesson',
}

export const reactionsData: ReactionsData[] = [
  {
    icon: <NeutralFace size={16} />,
    reaction: Reactions.NoReview,
    title: 'Воздержусь от оценки',
  },
  {
    icon: <ThumbsUpLightSkinTone size={16} />,
    reaction: Reactions.ProfessionalMentor,
    title: 'Преподаватель профессионал',
  },
  {
    icon: <Fire size={16} />,
    reaction: Reactions.GreatPresentation,
    title: 'Отличная подача материала',
  },
  {
    icon: <NerdFace size={16} />,
    reaction: Reactions.UsefulLesson,
    title: 'Полезное занятие',
  },
  { icon: <AnEasySmile size={16} />, reaction: Reactions.EasyToUnderstand, title: 'Все понятно' },
  {
    icon: <FaceWithSpiralEyes size={16} />,
    reaction: Reactions.HardToUnderstand,
    title: 'Сложно для понимания',
  },
  {
    icon: <DizzyFace size={16} />,
    reaction: Reactions.BadPresentation,
    title: 'Неудачная подача материала',
  },
  {
    icon: <ManFacepalming size={16} />,
    reaction: Reactions.BadOrganization,
    title: 'Плохая организация занятия',
  },
  {
    icon: <ConfusedFace size={16} />,
    reaction: Reactions.DidNotLikeThePresentation,
    title: 'Не нравится стиль преподавания',
  },
  {
    icon: <ExplodingHead size={16} />,
    reaction: Reactions.TooMuchInformation,
    title: 'Нового материала слишком много',
  },
]

export type ReactionsData = {
  icon: ReactNode
  reaction: Reactions
  title: string
}

export type ReactionsDataWithCount = { count: number } & ReactionsData
